
<template>
    <div>
        <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
            <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentMail">
                <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
                    <div class="flex mb-4">
                        <div class="flex items-center">
                            <feather-icon icon="ArrowLeftIcon" @click="refreshRepliedMessage" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                            <h4 v-if="currentMail.subject">{{ currentMail.subject }}</h4>
                            <h4 v-else>(no subject)</h4>
                        </div>
                    </div>

                </div>

                <VuePerfectScrollbar class="scroll-area md:px-8 pt-4 px-6" :settings="settings">
                <br>
                <div v-if="isSidebarActive" class="pb-6 mb-6">
                    <div class="vx-row">
                        <vx-card class="px-4 mx-4 p-6"  id="msgCard">
                            <div class="vx-col w-full">
                            <email-mail-card :mailContent="currentMail" />
                            </div>
                            <div v-if="currentMail.photo">
                                <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-6 flex mt-6">
                                    <feather-icon icon="PaperclipIcon" class="mr-2" />
                                    <span class="block py-4">ATTACHMENT</span>
                                </div>
                                <div class="mail__attachment">
                                    <vs-button color="primary" class="px-4 py-2 mr-3 pointer" @click="displayImage(currentMail.photo)">{{ currentMail.photo.split('/').pop() }}</vs-button>
                                </div>
                            </div>
                            <vs-popup class="holamundo showImage"  title="Result" :active.sync="showImage">
                                    <img :src="imageUrl" style="width:100%;"/>
                            </vs-popup>
                        </vx-card>
                    </div>
                    <div class="vx-row" style="margin-top: 2.2rem" v-if="!reply">
                        <div class="vx-col w-full pb-10">
                            <vx-card  id="msgCard">
                                <div class="vx-row p-4 px-6">
                                    <div class="vx-col w-full">
                                        <h6 class="mb-4">Post a reply<span v-if="errors.reply.success" class="sterik"> *</span></h6>
                                        <vs-textarea 
                                        v-model="replyContent"
                                        @input="validateReply(replyContent)"
                                        />
                                        <div v-show="errors.reply.success" class="dangerColor">{{ errors.reply.msg }}</div>
                                        <vs-row vs-justify="flex-end">
                                            <vs-button @click="addReply">Reply</vs-button>
                                        </vs-row>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                    <div class="my-6 mx-0 p-6" v-if="reply" id="msgCard">
                            <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center p-5">
                                <div class="flex items-center">
                                <div>
                                    <vs-avatar class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white" :src="reply.photo" size="65px" />
                                </div>

                                <div class="flex flex-col">
                                    <h5 class="mb-1">{{ reply.user.firstname+' '+reply.user.lastname }}</h5>
                                    <div class="flex items-center">
                                    <span class="text-sm my-3">{{ reply.user.email }}</span>
                                    </div>
                                </div>
                                </div>
                                <div class="flex flex-col justify-end my-4">
                                    <vs-row>
                                        <vs-avatar color="primary" text=" " size="14px"/>
                                        <span class="text-right mt-1 ml-2 mb-1">Admin</span>
                                    </vs-row>
                                    <span class="text-right my-3">{{ reply.date | formatMessageTime}}</span>
                                    <div>{{ reply.date | formatDate }}</div>
                                </div>
                            </div>
                            <div class="vx-row">
                            <div class="vx-col w-full p-5">
                                <div class="mail__content break-words mt-8 mb-4" v-html="reply.body"></div>
                            </div>
                            </div>
                    </div>
                </div>
                </VuePerfectScrollbar>
            </div>
        </vs-sidebar>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EmailMailCard from "./EmailMailCard.vue"

import EventBus from '@/event-bus.js';
import { genericErrorMessage, toast } from '@/keys/toast-messages';

import { validateReply } from '@/views/admin/validation';


export default {
  props: {
    email: {
      type: Array,
      required: true,
    },
    openMail: {
      required: true,
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showImage: false,
      imageUrl: '',

      reply: '',
      replyContent: '',

      showThread: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },

      errors: {
            reply: {
                msg: '',
                success: false
            }
        },
        validateReply,

        genericErrorMessage,
        toast
    }
  },
  watch: {
    isSidebarActive(value) {
        if(this.currentMail.reply){
            this.reply = {
                body: this.currentMail.reply,
                date: this.currentMail.reply_time,
                user: {
                    firstname: this.currentMail.admin.firstname,
                    lastname: this.currentMail.admin.lastname,
                    email: this.currentMail.admin.email,
                },
                photo: this.currentMail.base_url+this.currentMail.admin.photo
            }
        }
        else {
            this.reply = undefined;
        }

      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
  },
  computed: {
    currentMail() {
      return this.openMail
    },
  },
  methods: {
    refreshRepliedMessage(responseToReply){
        this.$emit('closeSidebar');
        this.$root.$emit('refreshMessageList',{});
        if(responseToReply.success == true){
            this.reply = undefined;
            this.replyContent = '';
            this.$root.$emit('refreshMessages',responseToReply);
        }
        else {
            
        }
    },
    displayImage(imageUrl){
        this.imageUrl = this.currentMail.base_url+this.currentMail.photo;
        this.showImage = true;
    },
    async addReply(){
        this.validateReply(this.replyContent);
        if(this.errors.reply.success == false && this.replyContent != ''){
            this.sendReply(this.currentMail)
        }
    },
     sendReply(currentMail){
        this.$vs.loading({
            background: 'rgba(1,2,3,.2)'
        });
        return new Promise((resolve, reject) => {
            this.$axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.MessagesReply,{
                messageId: currentMail._id,
                reply: this.replyContent,
                userEmail: currentMail.user.email
            }, { 
                headers: {
                    'Authorization': this.$localStorage.get('token')
                }
            }).then(async res => {
                this.$vs.loading.close();
                if(res.data.success){
                    let user = await JSON.parse(this.$localStorage.get('user'));
                    this.reply = {
                        id: currentMail._id,
                        user: { 
                            firstname: user.firstname,
                            lastname: user.lastname,
                            email: user.email
                        },
                        date: new Date(),
                        email: user.email,
                        body: this.replyContent,
                        photo: currentMail.base_url+user.photo,
                    }
                    
                    this.refreshRepliedMessage(res.data);
                    this.errors = {
                        reply: {
                            msg: '',
                            success: false
                        }
                    };
                } else {
                    this.toast(this.genericErrorMessage());
                }
            }).catch(e => {
                this.errors = {
                    reply: {
                        msg: 'Unable to send email at the moment',
                        success: true
                    }
                };
                this.$vs.loading.close();
                // console.log("Error in getCards: ",e.response);
            });
        });
    },
    moveTo(to) {
      this.$emit('closeSidebar')
      this.$emit('moveTo', to)
    }
  },
  components: {
    VuePerfectScrollbar,
    EmailMailCard
  },
  updated() {
    if (!this.currentMail) return
    if (this.currentMail.unread && this.isSidebarActive) this.email[0];
  },
}

</script>

<style>
.full-vs-sidebar .vs-sidebar {
    max-width: 100% !important;
    margin-left: 0 !important; 
}   
#msgCard {
    background-color:#1C1C1E !important;
    border-radius: 10px !important;
}
.dangerColor {
    color: #EA5455;
    font-size: 12px;
}
@media only screen and (max-width: 600px){
  .showImage .vs-popup {
      width: 100% !important;
  }
}
@media only screen and (min-width: 600px) {
  .showImage .vs-popup {
      width: 100% !important;
      margin-left: 0%;
  }
}
@media only screen and (min-width: 768px) {
  .showImage .vs-popup {
      width: 90% !important;
  }
}
@media only screen and (min-width: 992px) {
  .showImage .vs-popup {
      width: 80% !important;
  }
}
@media only screen and (min-width: 1080px) and (max-width: 1199px) {
  .showImage .vs-popup {
      width: 60% !important;
  }
}
@media only screen and (min-width: 1200px) {
  .showImage .vs-popup {
      width: 60% !important;
  }
}
</style>

